var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ipub-label flex-center",class:[
        _vm.type ? 'ipub-label--' + _vm.type : '',
        {
          'is-round': _vm.round
        },
        _vm.cover ? 'ipub-label--cover' : '',
        _vm.hover ? 'ipub-label--hover' : '',
        _vm.active ? 'ipub-label--active' : '',
        _vm.circle ? 'ipub-label--circle' : '',
        _vm.size ? 'ipub-label--' + _vm.size : ''
      ],on:{"click":_vm.handleClick,"mouseover":_vm.handleMouseover}},[(_vm.icon)?_c('IpubIcon',{staticClass:"ipub-label__icon",attrs:{"type":_vm.icon}}):_vm._e(),_vm._t("default"),(_vm.closable)?_c('IpubIcon',{staticClass:"ipub-label__action",attrs:{"type":"iconClose"},on:{"click":function($event){$event.stopPropagation();return _vm.handleClose.apply(null, arguments)}}}):_vm._e(),(_vm.addable)?_c('IpubIcon',{staticClass:"ipub-label__action",attrs:{"type":"iconAdd"},on:{"click":function($event){$event.stopPropagation();return _vm.handleAdd.apply(null, arguments)}}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }